import { getSpot } from '../utils'

export default class Destroyer {
  public spot: number;
  private puzzle: number[][][];
  private tickTime: number;
  private timer: number;
  private locked: boolean[][];

  constructor (puzzle: number[][][], locked: boolean[][], tickTime: number) {
    this.puzzle = puzzle
    this.locked = locked
    this.spot = -1
    this.tickTime = tickTime
    this.timer = 0
    this.run()
  }

  run () {
    this.timer = setInterval(() => {
      this.spot = Math.floor(Math.random() * 81)
      let [x, y] = getSpot(this.spot)
      while (this.locked[y][x]) {
        this.spot = Math.floor(Math.random() * 81)
        const spot = getSpot(this.spot)
        x = spot[0]
        y = spot[1]
      }
      this.destroy()
    }, this.tickTime)
  }

  destroy () {
    const [x, y] = getSpot(this.spot)
    this.puzzle[y][x].splice(0)
    this.puzzle[y][x].push(...[1, 2, 3, 4, 5, 6, 7, 8, 9])
  }

  isDestroying (x: number, y: number) {
    const [thisX, thisY] = getSpot(this.spot)
    return x === thisX && y === thisY
  }

  remove () {
    clearInterval(this.timer)
  }

  serialize () {
    return {
      tickTime: this.tickTime,
      spot: this.spot
    }
  }
}
